"use strict";

var _slicedToArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _toConsumableArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Simple = exports.simpleFn = void 0;

var _react = require("react");

var _Gradient = require("./Gradient");

var simplePointsFn = function simplePointsFn(state) {
  return function (ticker, points) {
    return [{
      state: state,
      time: ticker.now
    }].concat(_toConsumableArray(points.slice(0, 1)));
  };
};

var simpleGradientFn = function simpleGradientFn() {
  return function (ticker, _ref, state) {
    var _ref2 = _slicedToArray(_ref, 2),
        point0 = _ref2[0],
        point1 = _ref2[1];

    if (point1 == null) return 0;
    if (state === point0.state) return point0.state;
    var remain = point0.time - point1.time - (ticker.now - point0.time);
    var interp = state + (point0.state - state) / remain * ticker.deltaTime;
    return Math.max(state, Math.min(interp, point0.state));
  };
};

var simpleFn = function simpleFn(state) {
  var pointsFn = (0, _react.useCallback)(simplePointsFn(state), [state]);
  var gradientFn = (0, _react.useCallback)(simpleGradientFn(), []);
  return [pointsFn, gradientFn];
};

exports.simpleFn = simpleFn;

var Simple = function Simple(_ref3) {
  var children = _ref3.children,
      state = _ref3.state;
  var pipe = (0, _Gradient.useGradient).apply(void 0, _toConsumableArray(simpleFn(state)));
  return children(pipe);
};

exports.Simple = Simple;
Simple.displayName = 'Gradient.Simple';